import type { DesignSpaceEntity, IDesignSpaceConfig } from "./design-space";

/**
 * create an empty design space object to be populated by the user
 */
export function createDesignSpace<Config extends IDesignSpaceConfig>(
  config: Config,
): DesignSpaceEntity<Config> {
  return {
    id: "",
    data: {
      name: config.name,
      description: config.description,
      instance: config,
    },
    metadata: {
      created: {
        time: 0,
        user: "",
      },
      updated: {
        time: 0,
        user: "",
      },
      status: {
        name: "CREATED",
        detail: [],
        info: [],
      },
    },
  };
}
